import { Outlet } from "react-router-dom";
import Sidebar from "../components/Sidebar/Sidebar.js";
import Navbar from "../components/Navbar/Navbar.js";
import styles from "./Default.module.scss";
import { useState, useEffect } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import Notifications from "../components/Notifications/Notifications";

import { GoArrowLeft, GoArrowRight } from "react-icons/go";
import IconButton from "@mui/material/IconButton";

export default function Layout() {
  const matches = useMediaQuery("(min-width:1200px)");
  const [sidebar, setSideBar] = useState(matches);
  const [notification, setNotification] = useState(false);
  const [unseen, setUnseen] = useState(false);
  const changeSidebar = (e) => {
    setSideBar(!sidebar);
  };
  const getUnseen = async () => {
    setUnseen(2);
  };
  useEffect(() => {
    if (!matches) setSideBar(false);
    getUnseen();
  }, []);
  return (
    <>
      {matches && (
        <div
          onClick={changeSidebar}
          style={sidebar ? { left: "137px" } : { left: "40px" }}
          className={styles.Sidemenu}
        >
          <IconButton>
            {sidebar ? <GoArrowLeft /> : <GoArrowRight />}
          </IconButton>
        </div>
      )}

      <Sidebar clickHandler={changeSidebar} visible={sidebar} />
      <Navbar
        clickHandler={changeSidebar}
        sidebarVs={sidebar}
        notification={notification}
        setNotification={setNotification}
        unseen={unseen}
      />
      <div
        className={`${styles.contentWrapper} ${
          sidebar ? `` : `${styles.invisible}`
        }`}
      >
        {notification && (
          <Notifications
            getUnseen={getUnseen}
            setNotification={setNotification}
          />
        )}

        <Outlet />
      </div>
    </>
  );
}
